<script lang="jsx">
import { computed, defineComponent, ref, toRef, watch, nextTick } from "@nuxtjs/composition-api"
import { isClient, useResizeObserver, useMounted } from "@vueuse/core";
// import { watch } from "less";

import useEllipsis from './composables/useEllipsis'

import Ellipsis from './Ellipsis.vue';

import useMergedState from '~/composables/useMergedState'
export default defineComponent({
    props: {
        rows: {
            type: Number,
            default: 1
        },
        expandable: {
            type: Boolean,
            default: true
        },
        suffix: {
            type: String,
        },

        symbol: String,

        value: {

        }
    },
    emits: ['input', 'change'],
    setup(props, { slots, emit }) {

        const rootRef = ref();
        const [mergedExpand, setMergedExpand] = useMergedState(() => props.value, {
            value: toRef(props, 'value'),
            onChange: (val, preval) => {
                // console.log('click')
                emit('input', val)
                if (val !== preval) {
                    nextTick(() => {
                        emit('change', val)
                    })
                }

            }
        })
        const {
            isLineClampSupport,
            isTextOverflowSupport,

            // expanded,
            isJsEllipsis,
            isNativeEllipsis,
            isNativeVisible,
            mergedEnableEllipsis
        } = useEllipsis(mergedExpand);



        // const slots = useS
        const needMeasureEllipsis = computed(() => !mergedEnableEllipsis.value || props.suffix !== undefined || !!slots.suffix || props.expandable)
        // const rows
        const cssEllipsis = computed(() => {
            if (needMeasureEllipsis.value) {
                return false;
            }
            if (props.rows === 1) {
                return isTextOverflowSupport.value
            }

            return isLineClampSupport.value;
        })


        const isMergedEllipsis = computed(() => mergedEnableEllipsis.value && (cssEllipsis.value ? isNativeEllipsis.value : isJsEllipsis.value));

        const cssTextOverflow = computed(() => mergedEnableEllipsis.value && props.rows === 1 && cssEllipsis.value);

        const cssLineClamp = computed(() => mergedEnableEllipsis.value && props.rows > 1 && cssEllipsis.value);


        // >>>>>>>>> Expand
        /**
         *
         * @param { Event } e
         */
        const onExpandClick = (e) => {
            e.preventDefault();
            // expanded.value = true;
            setMergedExpand(true);
            emit('expand')
        }

        const ellipsisWidth = ref(0);
        const ellipsisFontSize = ref(0);

        useResizeObserver(rootRef, ([entry]) => {
            const { width } = entry.contentRect
            ellipsisWidth.value = width;
            ellipsisFontSize.value = parseInt(window.getComputedStyle(rootRef.value)?.fontSize, 10)
        })



        // >>>>>>>>> JS Ellipsis
        const onJsEllipsis = (isJsEllipsis) => {
            isJsEllipsis.value = isJsEllipsis;
        }


        // >>>>>>>> Native ellipsis
        watch(() => [cssEllipsis.value, cssLineClamp.value, isNativeVisible.value], () => {
            const textEle = rootRef.value;
            if (cssEllipsis.value && textEle) {
                const currentEllipsis = cssLineClamp.value
                    ? textEle.offsetHeight < textEle.scrollHeight
                    : textEle.offsetWiedth < textEle.scrollWidth;

                if (isNativeEllipsis.value !== currentEllipsis) {
                    isNativeEllipsis.value = currentEllipsis;
                }
            }
        })

        const isMounted = useMounted();

        return {
            rootRef,
            isMounted,

            isLineClampSupport,
            isTextOverflowSupport,

            // expanded,
            isJsEllipsis,
            isNativeEllipsis,
            isNativeVisible,
            mergedEnableEllipsis,
            needMeasureEllipsis,
            cssEllipsis,
            isMergedEllipsis,
            cssTextOverflow,
            cssLineClamp,

            onExpandClick,
            ellipsisWidth,
            ellipsisFontSize,


            onJsEllipsis
        }
    },
    render(h) {
        const prefixCls = 'v-ellipsis'
        // const needMeasureEllipsis = !mergedEnableEllipsis || this.suffix !== undefined || this.expand
        const children = this.$slots.default;
        const ELLIPSIS_STR = '...';
        const { suffix, expandable, symbol } = this;
        const vm = this;
        const renderExpand = () => {
            if (!expandable) {
                return null
            }
            let expandContent;
            if (symbol) {
                expandContent = symbol;
            }

            return h('a', {
                class: [`${prefixCls}-expand`],
                on: {
                    click: this.onExpandClick
                }
            }, [expandContent])
            //  <a class={`${prefixCls}-expand`} key='expand' onClick={this.onExpandClick}>{expandContent}</a>
        }
        function renderEllipsis(needEllipsis) {
            return [
                needEllipsis && (h('span', { key: 'ellipsis', attrs: { 'aria-hidden': true } }, [ELLIPSIS_STR])),
                vm.$slots.suffix ? vm.$slots.suffix : suffix,
                needEllipsis ? renderExpand(needEllipsis) : null
            ]
        }

        return h('div', {
            ref: (el) => this.rootRef = el
        }, [this.isMounted ? h(Ellipsis, {
            class: {
                [`${prefixCls}-ellipsis`]: this.enableEllipsis,
                [`${prefixCls}-single-line`]: this.rows === 1 && this.mergedEnableEllipsis,
                [`${prefixCls}-ellipsis-single-line`]: this.cssTextOverflow,
                [`${prefixCls}-ellipsis-multiple-line`]: this.cssLineClamp,
            },
            props: {
                enabledMeasure: this.mergedEnableEllipsis && !this.cssEllipsis,
                width: this.ellipsisWidth,
                fontSize: this.ellipsisFontSize,
                rows: this.rows,
                text: children
            },
            scopedSlots: {
                default: (node, needEllipsis) => {
                    let renderNode = node;
                    if (node.length && needEllipsis) {
                        renderNode = h('span', {
                            key: 'show-conten',
                            attrs: {
                                'aria-hidden': true
                            }
                        }, [renderNode])

                        // <span key="show-content" aria-hidden>
                        //     {renderNode}
                        // </span>
                    }
                    return [renderNode, renderEllipsis(needEllipsis)];

                }
            }
        }) : null])

        // return <div ref={el => this.rootRef = el} >
        //     <Ellipsis
        //         class={}
        //         enabledMeasure={this.mergedEnableEllipsis && !this.cssEllipsis}
        //         width={this.ellipsisWidth}
        //         fontSize={this.ellipsisFontSize}
        //         rows={this.rows}
        //         text={children}
        //     >{}}</Ellipsis>
        // </div>
    }
})
</script>

<style lang="scss">
.v-ellipsis-single-line {
  white-space: nowrap;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
.v-ellipsis-multiple-line {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.v-ellipsis-expand {
  cursor: pointer;
  margin-left: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(22, 53, 144, var(--tw-text-opacity));
}
</style>
